import { pick } from 'lodash-es'
import { useDittoStore } from './stores/DittoProvider'

export default function useDitto() {
  const {
    appId,
    ditto,
    tbId,
    onFetchRemoteData,
    upload,
    beforeTransform,
    addWatermarkToImage,
    extendDitto,
  } = useDittoStore((state) =>
    pick(state, [
      'appId',
      'ditto',
      'tbId',
      'onFetchRemoteData',
      'upload',
      'addWatermarkToImage',
      'beforeTransform',
      'extendDitto',
    ])
  )

  return {
    appId,
    ditto,
    tbId,
    upload,
    addWatermarkToImage,
    onFetchRemoteData,
    beforeTransform,
    extendDitto,
  }
}
